import React from "react"
export const ErrorMsg = ({ title, className }) => {
  return (
    <>
      <p className={`text-red absolute -bottom-5 left-1 w-full ${className}`}>
        {title}
      </p>
    </>
  )
}